import { useEffect } from "react";

import { useLocation } from "react-router-dom";

import { useGenericSessionStorage } from "./useSessionStorage";

interface UrlParams {
  coupon?: string;
  type?: string;
}

/**
 * URLパラメータのcouponとtypeをセッションストレージに自動保存するフック
 */
export const useUrlParamsToSessionStorage = () => {
  const location = useLocation();
  const [storedParams, setStoredParams] = useGenericSessionStorage<UrlParams>("urlParams", {});

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const coupon = searchParams.get("coupon");
    const type = searchParams.get("type");

    // couponまたはtypeパラメータが存在する場合のみセッションストレージを更新
    if (coupon || type) {
      const newParams: UrlParams = {};
      
      if (coupon) {
        newParams.coupon = coupon;
      }
      
      if (type) {
        newParams.type = type;
      }

      // 既存のパラメータと新しいパラメータをマージ
      const updatedParams = { ...storedParams, ...newParams };
      setStoredParams(updatedParams);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return storedParams;
};

/**
 * セッションストレージからURLパラメータを取得するフック
 */
export const useStoredUrlParams = () => {
  const [storedParams] = useGenericSessionStorage<UrlParams>("urlParams", {});
  return storedParams;
};

/**
 * セッションストレージのURLパラメータをクリアするフック
 */
export const useClearStoredUrlParams = () => {
  const [, setStoredParams] = useGenericSessionStorage<UrlParams>("urlParams", {});
  
  const clearParams = () => {
    setStoredParams(null);
  };

  return clearParams;
};
